import { NotificationModel } from 'models';
import { AddNotificationAction } from './actions/addNotification';
import { RemoveNotificationAction } from './actions/removeNotification';

export enum NotificationsActionTypes {
    ADD_NOTIFICATION = 'notifications/ADD_NOTIFICATION',
    REMOVE_NOTIFICATION = 'notifications/REMOVE_NOTIFICATION'
}

export interface NotificationsState {
    notifications: NotificationModel[];
}

export type NotificationsActions =
    AddNotificationAction
    | RemoveNotificationAction;